/**
 * API endpoint constants
 * Centralized API endpoint definitions
 */

const interpolateEndpoint = (pattern, params = {}) => {
  let url = pattern;

  Object.entries(params).forEach(([key, value]) => {
    url = url.replace(`:${key}`, encodeURIComponent(value));
  });

  return url;
};

export const API_ENDPOINTS = {
  AUTH: {
    TOKEN_OBTAIN: "/api/auth/token/obtain/",
    TOKEN_REFRESH: "/api/auth/token/refresh/",
    STEAM_LOGIN: "/api/auth/steam/",
  },
  USER: {
    ME: "/api/users/me/",
    BALANCE: "/api/users/balance/",
  },
  MARKET: {
    CATALOG: "/api/market/catalog/",
    ITEM_DETAIL: (id) =>
      interpolateEndpoint("/api/market/catalog/:id/", { id }),
    PURCHASE: "/api/market/purchase/",
    PURCHASE_HISTORY: "/api/market/purchases/",
  },
  ONLINE: {
    SUMMARY: "/api/game/summary/",
  },
  SERVERS: {
    LIST: "/api/game/servers/",
  },
  LEADERBOARD: {
    LIST: "/api/game/leaderboards/",
  },
  NEWS: {
    LIST: "/api/news/",
    DETAIL: (slug) => interpolateEndpoint("/api/news/:slug/", { slug }),
    UPDATE: (id) => interpolateEndpoint("/api/news/action/:id/", { id }),
    DELETE: (id) => interpolateEndpoint("/api/news/action/:id/", { id }),
  },
  ROADMAP: {
    LIST: "/api/roadmap/",
  },
  MONITORING: {
    ONLINE: "/api/game/monitoring/online/",
  },
};

export const API_CONFIG = {
  TIMEOUT: 10000,
  RETRY_ATTEMPTS: 3,
};

export default API_ENDPOINTS;
